

<!-- CartSummary.svelte -->

<script>
  import { onMount } from 'svelte';
  import { createEventDispatcher } from 'svelte';
  import DeliveryPointModal from './DeliveryPointModal.svelte';
  import DeliverySlotModal from './DeliverySlotModal.svelte';
  import Menu from './Menu.svelte';
  import backarrow from './assets/backarrow.png';
  
  let showSlotModal = false;
  let availableDeliverySlots = [];
  
  import OutOfStockPopup from './OutOfStockPopup.svelte'; 
  import OutOfStockPopup2 from './OutOfStockPopup2.svelte';  
  let isLoading = false;
  const dispatch = createEventDispatcher();

  import { App } from '@capacitor/app';
  import { Capacitor } from '@capacitor/core';
  import { StatusBar } from '@capacitor/status-bar';

  let statusBarHeight = 0;
  let checkoutResponse = {};
  let deliveryPointStatus = null;
  let isLoadingDeliveryPoint = false;
  let isOrderButtonActive = false;
  let selectedDeliveryPoint = 0;
  let selectedDeliverySlot = 0;
  let pickupDate = "0000-00-00";
  let pickupDay = "";
  let showModal = false;
  let availableDeliveryPoints = [];
  let updatingItems = new Set();
  let isUpdatingTotal = false;
  let isPlacingOrder = false;
  let showPaymentModal = false;
  let showPaymentFailedModal = false;
  let isStartingPayment = false;  
  let isProcessingPayment = false;
  let currentOrderId = null;
  let userPaymentPreference = '';
  let showOutOfStockPopup = false;
  let showUpiLoader = false;

  let showOutOfStockPopup2 = false;
  let outOfStockError2 = null;

  let cutOffTime = "";
  let showNewSlotPopup = false;
  let newDeliverySlotTime = "";
  
  let loadingButton = null;  
  

 

  
  onMount(async () => {
    await initializeComponent();

    // Show the popup if there are products not added
    if (checkoutResponse.products_not_added && checkoutResponse.products_not_added.length > 0) {
      showOutOfStockPopup = true;
    }

    if (Capacitor.isNativePlatform()) {
     App.addListener('backButton', handlePhoneBackButton);
     const { height } = await StatusBar.getInfo();
     statusBarHeight = height;
     document.documentElement.style.setProperty('--status-bar-height', `${height}px`);

    }

    // Check if we've returned from a payment app
    if (document.hidden !== undefined) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
  });

  async function initializeComponent() {
    const storedResponse = localStorage.getItem('checkoutResponse');
    if (storedResponse) {
      checkoutResponse = JSON.parse(storedResponse);
	  userPaymentPreference = checkoutResponse.cart.user_payment_preference;
      saveCartToLocalStorage(checkoutResponse.cart);

      // Assign pickupDate here
      pickupDate = checkoutResponse.cart.pickup_date;
    } else {
      console.warn('No checkoutResponse found in localStorage');
    }

    isLoadingDeliveryPoint = true;
    if (checkoutResponse.cart) {
      await fetchDeliveryPointStatus();
    }
    isLoadingDeliveryPoint = false;

    updateOrderButtonState();
    
    // Force a re-render
    checkoutResponse = { ...checkoutResponse };
  }


	function handleVisibilityChange() {
	  if (!document.hidden && currentOrderId !== null) {
		checkOrderStatus(currentOrderId);
	  }
	}




  async function fetchDeliveryPointStatus() {
    if (!checkoutResponse.cart) return;

    try {
      const categoryId = checkoutResponse.cart.category_id;
      const accessToken = localStorage.getItem('accessToken');


      const response = await fetch('https://groupfruits.online/shop/api/NewDeliveryPointAvailabilityCheckView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${accessToken}`,
        },
        body: JSON.stringify({
          category_id: categoryId,
          delivery_point_id: selectedDeliveryPoint
        }),
      });

      if (response.ok) {
        deliveryPointStatus = await response.json();
        console.log('deliveryPointStatus:', deliveryPointStatus);

		  // Update pickupDate only if it exists in the response
		  if (deliveryPointStatus.pickup_date) {
			pickupDate = deliveryPointStatus.pickup_date;
		  }


		  // Update pickupDay only if it exists in the response
		  if (deliveryPointStatus.pickup_day) {
			pickupDay = deliveryPointStatus.pickup_day;
		  }


			if (deliveryPointStatus.delivery_slot && deliveryPointStatus.delivery_slot.cut_off_timestamp) {
			  cutOffTime = deliveryPointStatus.delivery_slot.cut_off_timestamp;
			}


        // Update selectedDeliveryPoint and selectedDeliverySlot
        if (deliveryPointStatus.availability_status === 'Yes') {
          selectedDeliveryPoint = deliveryPointStatus.delivery_point.id;
          selectedDeliverySlot = deliveryPointStatus.delivery_slot.id;
        }

        updateOrderButtonState();
      } else {
        console.error('Error fetching delivery point status:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }

    updateOrderButtonState();
  }





  async function RecheckDeliveryPointStatus() {
    if (!checkoutResponse.cart) return;

    try {
      const categoryId = checkoutResponse.cart.category_id;
      const accessToken = localStorage.getItem('accessToken');


      const response = await fetch('https://groupfruits.online/shop/api/NewDeliveryPointAvailabilityCheckView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${accessToken}`,
        },
        body: JSON.stringify({
          category_id: categoryId,
          delivery_point_id: selectedDeliveryPoint
        }),
      });

      if (response.ok) {
        deliveryPointStatus = await response.json();
        console.log('deliveryPointStatus:', deliveryPointStatus);

		  // Update pickupDate only if it exists in the response
		  if (deliveryPointStatus.pickup_date) {
			pickupDate = deliveryPointStatus.pickup_date;
		  }


		  // Update pickupDay only if it exists in the response
		  if (deliveryPointStatus.pickup_day) {
			pickupDay = deliveryPointStatus.pickup_day;
		  }

			if (deliveryPointStatus.delivery_slot && deliveryPointStatus.delivery_slot.cut_off_timestamp) {
			  cutOffTime = deliveryPointStatus.delivery_slot.cut_off_timestamp;
			}


        // Update selectedDeliveryPoint and selectedDeliverySlot
        if (deliveryPointStatus.availability_status === 'Yes') {
          selectedDeliveryPoint = deliveryPointStatus.delivery_point.id;
        }

        updateOrderButtonState();
      } else {
        console.error('Error fetching delivery point status:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }

    updateOrderButtonState();
  }




  async function fetchAvailableDeliveryPoints() {
    if (!checkoutResponse.cart) return;
    isLoading = true; 
    try {
      const categoryId = checkoutResponse.cart.category_id;
      const accessToken = localStorage.getItem('accessToken');

      const response = await fetch('https://groupfruits.online/shop/api/AvailableDeliveryPointsView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${accessToken}`,
        },
        body: JSON.stringify({
          category_id: categoryId,
        }),
      });

      if (response.ok) {
        availableDeliveryPoints = await response.json();
      } else {
        console.error('Error fetching delivery points:', response.statusText);
      }
	   } catch (error) {
		console.error('Network error:', error);
	  } finally {
		isLoading = false; // Add this line
	  }
	}

async function fetchAvailableDeliverySlots() {
  if (!checkoutResponse.cart) return;
  isLoading = true; // Show loading indicator immediately
  try {
    const accessToken = localStorage.getItem('accessToken');
    const response = await fetch('https://groupfruits.online/shop/api/AvailableSlotsView/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWT ${accessToken}`,
      },
      body: JSON.stringify({
        category_id: checkoutResponse.cart.category_id,
        delivery_point_id: selectedDeliveryPoint
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // Handle the case where no slots are available
      if (data.message === "No available slots found") {
        return []; // Return an empty array to indicate no slots
      }
      return data; 
    } else {
      console.error('Error fetching delivery slots:', response.statusText);
      return []; // Return an empty array in case of error
    }
  } catch (error) {
    console.error('Network error:', error);
    return []; // Return an empty array in case of error
  } finally {
    isLoading = false; // Hide loading indicator after the request is complete
  }
}


  function handleOpenModal() {
    fetchAvailableDeliveryPoints();
    showModal = true;
  }

  function handleModalClose() {
    showModal = false;
  }

  function handleDeliveryPointSelection(event) {
    const deliveryPointId = event.detail;

    if (Number.isInteger(deliveryPointId) && deliveryPointId >= 0) {
      selectedDeliveryPoint = deliveryPointId;
      showModal = false;

      fetchDeliveryPointStatus();
    } else {
      console.error('Invalid delivery point ID:', deliveryPointId);
    }
  }


async function handleOpenSlotModal() {
  availableDeliverySlots = await fetchAvailableDeliverySlots();
  showSlotModal = true;
}

async function handleDeliverySlotSelection(event) {
  const slotId = event.detail;
  selectedDeliverySlot = slotId;
  showSlotModal = false;
  await fetchDeliveryPointStatus();
}


  function updateOrderButtonState() {
    const hasTotalPrice = checkoutResponse.cart && checkoutResponse.cart.total_price > 0;
    const isDeliveryAvailable = deliveryPointStatus && deliveryPointStatus.availability_status === 'Yes';
    isOrderButtonActive = hasTotalPrice && isDeliveryAvailable && !isUpdatingTotal && updatingItems.size === 0;
  }


async function handleOrderNow() {
  // Check if the current time has passed the cut-off time
  if (Date.now() / 1000 > cutOffTime) {
    // Re-fetch delivery point availability
    await RecheckDeliveryPointStatus();

    if (deliveryPointStatus && deliveryPointStatus.availability_status === 'Yes') {
      // Always check if the slot has changed, even if still available
      if (deliveryPointStatus.delivery_slot.id !== selectedDeliverySlot) {
        // Update the selectedDeliverySlot
        selectedDeliverySlot = deliveryPointStatus.delivery_slot.id;

        // Extract the new delivery slot time
        newDeliverySlotTime = formatTime(deliveryPointStatus.delivery_slot.delivery_time);

        // Show the popup
        showNewSlotPopup = true;

        return; // Stop further execution of handleOrderNow
      }
    } 
  }

  showPaymentModal = true; 
}


  function handleNewSlotOkay() {
    showNewSlotPopup = false;
    showPaymentModal = true; // Proceed with the order
  }
  
  
function closeOutOfStockPopup2() {
  showOutOfStockPopup2 = false;
  outOfStockError2 = null;
}

async function placeOrder(selectedApp) {
  console.log('placeOrder function called with:', selectedApp);
  if (isPlacingOrder) return;
  isPlacingOrder = true;
  isStartingPayment = (selectedApp === 'phonepeUrl' || selectedApp === 'gpayUrl');

  if (selectedApp === 'intentUrl') {
    showUpiLoader = true;
  }

  const accessToken = localStorage.getItem('accessToken');
  try {
    console.log('Sending request to MergedCreateOrder API');
    const response = await fetch('https://groupfruits.online/shop/api/MergedCreateOrder/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWT ${accessToken}`,
      },
      body: JSON.stringify({
        cart_id: checkoutResponse.cart.id,
        delivery_point_id: selectedDeliveryPoint,
        delivery_slot_id: selectedDeliverySlot,
		pickup_date: pickupDate,
        selected_app: selectedApp
      })
    });
    
    console.log('Response received:', response.status, response.statusText);
    const data = await response.json();
    console.log('Response data:', data);

    if (response.ok) {
      localStorage.setItem('orderResponse', JSON.stringify(data));
      saveCartToLocalStorage(data.cart);
      currentOrderId = data.order.id;
      
      if (selectedApp === 'intentUrl') {
        setTimeout(() => {
          window.open(data.selected_app_deeplink, '_system');
          showUpiLoader = false;
        }, 100);
      } else {
        window.open(data.selected_app_deeplink, '_system');
        // Introduce a delay before resetting isStartingPayment
        setTimeout(() => {
          isStartingPayment = false;
        }, 2000); // Adjust the delay as needed
      }
    } else {
      console.log('Response not OK, checking for unavailable_items');
      if (data.error && typeof data.error === 'string' && data.error.includes('unavailable_items')) {
        console.log('Unavailable items detected, showing popup');
        outOfStockError2 = data;
        showOutOfStockPopup2 = true;
      } else {
        console.error('Error placing order:', data.error || response.statusText);
      }
    }
  } catch (error) {
    console.error('Network error:', error);
  } finally {
    console.log('Resetting state variables');
    isPlacingOrder = false;
    showPaymentModal = false;
    showUpiLoader = false;
  }
}

  $: console.log('showOutOfStockPopup2:', showOutOfStockPopup2);
  $: console.log('outOfStockError2:', outOfStockError2);
  
  
  async function checkOrderStatus(orderId) {
    const accessToken = localStorage.getItem('accessToken');
    let attempts = 0;
    const maxAttempts = 7;
    const startTime = Date.now();
    const timeoutDuration = 35000; // 35 seconds in milliseconds
    isStartingPayment = false;
    isProcessingPayment = true;

    const checkStatus = async () => {
      if (attempts >= maxAttempts || Date.now() - startTime > timeoutDuration) {
        console.log('Reached max attempts or timeout. Stopping status checks.');
        handlePaymentFailure();
        return;
      }

      attempts++;
      try {
        const response = await fetch('https://groupfruits.online/shop/api/OrderSummaryView/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWT ${accessToken}`,
          },
          body: JSON.stringify({ order_id: orderId })
        });

        if (response.ok) {
          const data = await response.json();
          const paymentStatus = data.order.payment_status;
          
          if (paymentStatus === 'successful') {
            isProcessingPayment = false;
			currentOrderId = null;
            dispatch('orderPlaced', { orderId });
            return;
          } else if (paymentStatus === 'failed') {
            handlePaymentFailure();
            return;
          }
          // If status is neither successful nor failed, continue to retry
        } else {
          console.error('Error fetching order status:', response.statusText);
        }
      } catch (error) {
        console.error('Network error:', error);
      }

      // Schedule next check
      setTimeout(checkStatus, 3000); // Check every 3 seconds
    };

    checkStatus();
  }

  async function handlePaymentFailure() {
    isStartingPayment = false;
    isProcessingPayment = false;
    showPaymentModal = false;
    showPaymentFailedModal = true;
    currentOrderId = null;
    
    // Reload the checkout response from localStorage
    const storedResponse = localStorage.getItem('checkoutResponse');
    if (storedResponse) {
      checkoutResponse = JSON.parse(storedResponse);
    }

    // Refetch delivery point status
    if (checkoutResponse.cart) {
      isLoadingDeliveryPoint = true;
      await fetchDeliveryPointStatus();
      isLoadingDeliveryPoint = false;
    }

    updateOrderButtonState();
    
    // Force a re-render
    checkoutResponse = { ...checkoutResponse };
  }



async function placeCashOrder() {
  if (isPlacingOrder) return;

  isPlacingOrder = true;
  const accessToken = localStorage.getItem('accessToken');

  try {
    const response = await fetch('https://groupfruits.online/shop/api/MergedCreateOrder/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWT ${accessToken}`,
      },
      body: JSON.stringify({
        cart_id: checkoutResponse.cart.id,
        delivery_point_id: selectedDeliveryPoint,
		delivery_slot_id: selectedDeliverySlot,
		pickup_date: pickupDate
      })
    });

    console.log('Response received:', response.status, response.statusText);
    const data = await response.json();
    console.log('Response data:', data);

    if (response.ok) {
      localStorage.setItem('orderResponse', JSON.stringify(data));
      saveCartToLocalStorage(data.cart);

      currentOrderId = data.order.id;

      // Close the payment modal
      showPaymentModal = false;

      // Dispatch the orderPlaced event
      dispatch('orderPlaced', { orderId: currentOrderId });

    } else {
      console.log('Response not OK, checking for unavailable_items');
      if (data.error && typeof data.error === 'string' && data.error.includes('unavailable_items')) {
        console.log('Unavailable items detected, showing popup');
        outOfStockError2 = data;
        showOutOfStockPopup2 = true;
      } else {
        console.error('Error placing order:', data.error || response.statusText);
      }
    }
  } catch (error) {
    console.error('Network error:', error);
  } finally {
    console.log('Resetting state variables');
    isPlacingOrder = false;
    isStartingPayment = false;
    showPaymentModal = false;
    showUpiLoader = false;
  }
}






  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }



function formatTime(time24) {
    const [hours, minutes] = time24.split(':');
    const hours12 = (parseInt(hours) % 12 || 12).toString().padStart(2, '0');
    const ampm = parseInt(hours) >= 12 ? 'PM' : 'AM';
    return `${hours12}:${minutes} ${ampm}`;
}
  
  
async function updateCartItem(productId, newQuantity) {
  updatingItems.add(productId);
  updatingItems = updatingItems;
  isUpdatingTotal = true;

  const accessToken = localStorage.getItem('accessToken');

  try {
    const response = await fetch('https://groupfruits.online/shop/api/UpdateCartItemView/', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWT ${accessToken}`,
      },
      body: JSON.stringify({
        category_id: checkoutResponse.cart.category_id,
        product_id: productId,
        quantity: newQuantity
      })
    });

    if (response.ok) {
      const updatedCart = await response.json();
      checkoutResponse = { ...checkoutResponse, cart: updatedCart.cart };
      localStorage.setItem('checkoutResponse', JSON.stringify(checkoutResponse));
      saveCartToLocalStorage(updatedCart.cart); 
    } else {
      console.error('Error updating cart item:', response.statusText);
    }
  } catch (error) {
    console.error('Network error:', error);
  } finally {
    updatingItems.delete(productId);
    updatingItems = updatingItems;
    isUpdatingTotal = false;
    updateOrderButtonState();
  }
}

  function handleQuantityChange(productId, newQuantity) {
    if (updatingItems.has(productId)) return;
    updateCartItem(productId, newQuantity);
  }

  function saveCartToLocalStorage(cart) {
    if (cart && cart.category_id) {
      const cartToSave = cart.items.map(item => ({
        id: item.product__id,
        quantity: item.quantity,
        price: item.price,
		image: item.product__image,
		inventorywarehousev2__price: item.price,
		measurement_unit: item.product__measurement_unit,
		title: item.product__title,
		unit: item.product__unit,
		approximate_unit: item.product__approximate_unit,
      }));
      localStorage.setItem(`cart-${cart.category_id}`, JSON.stringify(cartToSave));
    }
  }

  function handleBackButtonClick() {
    const categoryId = checkoutResponse.cart.category_id;
    dispatch('backToProducts', { categoryId });
  }

function handlePhoneBackButton() {
  if (Capacitor.isNativePlatform()) {
	const categoryId = checkoutResponse.cart.category_id;
	dispatch('backToProducts', { categoryId });
  }
}


  function closePaymentModal() {
    showPaymentModal = false;
  }

  function closePaymentFailedModal() {
    showPaymentFailedModal = false;
  }
  
  function closeOutOfStockPopup() {
    showOutOfStockPopup = false;
  }



  async function handlePaymentClick(paymentMethod) {
    loadingButton = paymentMethod;
    try {
      if (paymentMethod === 'cash') {
        await placeCashOrder();
      } else {
        await placeOrder(paymentMethod);
      }
    } finally {
      loadingButton = null;
    }
  }





  let countdownTime = 35;

  function startCountdown() {
    countdownTime = 35;
    const countdownInterval = setInterval(() => {
      countdownTime--;
      if (countdownTime <= 0) {
        clearInterval(countdownInterval);
      }
    }, 1000);
  }

  $: if (isProcessingPayment) {
    startCountdown();
  }

  function formatTimeCheck(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }




</script>




<style>
:global(body) {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  background-color: #ffffff;
  font-family: 'Roboto', sans-serif;
  margin: 0;
}

* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.back-button-container1 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 100;
  border-bottom: 0.1px solid #e5dada;
  display: flex;
  align-items: center;
  padding-top: calc(1.1vh + env(safe-area-inset-top));
  padding-bottom: calc(1.1vh + env(safe-area-inset-top));
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

.back-button1 {
  background: none;
  border: none;
  padding: 1vh 2vw;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.back-button1 img {
  width: 6vw;
  height: 6vw;
  max-width: 24px;
  max-height: 24px;
  margin-right: 1vw;
}

.container, .container2 {
  background-color: white;
  border-radius: 3vw;
  box-shadow: 0 1vw 1.5vw rgba(0, 0, 0, 0.1);
  padding: 4vw;
  margin: 4vw 2.5vw;
  border: 0.25vw solid #e0e0e0;
}

.container1 {
  background-color: white;
  border-radius: 3vw;
  padding: 5vw 4vw;
  margin: 4vw 2.5vw;
  border: 0.25vw solid #e0e0e0;
}

.pickup-info {
  display: flex;
  align-items: center;
}

.section-title {
  font-size: 4.5vw;
  font-weight: 600;
  color: #333;
  margin-right: 1vw;
  margin-bottom: 3vw;
  margin-top: 3vw;	
  margin-left: 0.75vw;
}

.pickup-date {
  font-size: 4vw;
  color: #4a4a4a;
  margin-bottom: 3vw;
  margin-top: 3vw;
}

.delivery-point {
  background-color: #e8f5e9;
  border-radius: 2vw;
  padding: 4vw;
  margin-top: 1.5vw;
}

.delivery-point-area-label {
  font-weight: 600;
  color: #2e7d32;
  margin-bottom: 2vw;
}

.delivery-point-title {
  color: #4a4a4a;
  line-height: 1.4;
  margin-bottom: 0;
}


.delivery-point-address {
  color: #4a4a4a;
  line-height: 1.4;
  margin-top: 0;
}

.unavailable {
  background-color: #ffebee;
}

.unavailable .delivery-point-name {
  color: #c62828;
}

.unavailable-label {
  color: #c62828;
  font-weight: 600;
  margin-top: 2vw;
}

.change-delivery-point-button {
  background-color: transparent;
  color: #1976d2;
  border: 0.5vw solid #1976d2;
  border-radius: 1.5vw;
  padding: 2vw 4vw;
  font-size: 3.5vw;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 4vw;
}

.user-details {
  margin-top: 2.5vw;
  margin-bottom: 2.5vw;
}

.user-info {
  font-size: 4vw;
  color: #4a4a4a;
  margin: 3vw 0;
}

.cart-summary-bar {
  background-color: #e3f2fd;
  color: #1565c0;
  padding: 3vw;
  border-radius: 2vw;
  font-weight: 600;
  margin-bottom: 4vw;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4vw;
  padding-bottom: 4vw;
  padding-left: 1.75vw;
  border-bottom: 0.25vw solid #f0f0f0;
}

.cart-item-details {
  flex-grow: 1;
  width: 70%;
  margin-right: 3.75vw;
}

.cart-item-title {
  font-size: 4vw;
  font-weight: 500;
  margin-bottom: 2vw;
  margin-top: 0;
}

.cart-item-price {
  font-size: 3.75vw;
  color: #7B7676;
  margin: 0;
  padding-bottom: 3.75vw;
}

.cart-item-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.cart-quantity-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 20vw;
  height: 7vw;
  border: 0.25vw solid #FF0F39;
  border-radius: 1vw;
  overflow: hidden;
}

.cart-quantity-button button {
  background-color: transparent;
  color: #FF0F39;
  border: none;
  font-size: 4.5vw;
  cursor: pointer;
  padding: 0;
  width: 7vw;
  height: 7vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.cart-quantity-button span {
  font-size: 3.5vw;
  color: #FF0F39;
  font-weight: bold;
}

.cart-item-subtotal {
  font-size: 3.75vw;
  color: #231F1F;
  margin-top: 2vw;
  text-align: center;
  font-weight: 600;
  margin-bottom: 0;
}

.loading {
  opacity: 0.5;
  pointer-events: none;
}

.total-price {
  font-size: 4.5vw;
  font-weight: 600;
  color: #333;
  text-align: right;
  margin-top: 4vw;
}

.confirm-button-container {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 10;
  background-color: white;
  padding-bottom: max(3vw, env(safe-area-inset-bottom));
}

.confirm-button {
  width: 100%;
  padding: 6.5vw;
  background-color: #4caf50;
  color: white;
  border: none;
  font-size: 4.5vw;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5vw;
  margin-bottom: 0;
}

.confirm-button.disabled {
  background-color: #bdbdbd;
  cursor: not-allowed;
}

.main-content1 {
  padding-top: calc(12.5vw + env(safe-area-inset-top));
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

.spinner {
  display: inline-block;
  width: 5vw;
  height: 5vw;
  border: 0.75vw solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.payment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-top: env(safe-area-inset-top);
  padding-bottom: max(3vw, env(safe-area-inset-bottom));
}

.payment-modal {
  background-color: white;
  padding: 5vw;
  border-top-left-radius: 5vw;
  border-top-right-radius: 5vw;
  box-shadow: 0 -0.5vw 2.5vw rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 125vw;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

.close-modal-button {
  position: absolute;
  top: 2.5vw;
  right: 2.5vw;
  background: none;
  border: none;
  font-size: 6vw;
  cursor: pointer;
}

.payment-button {
  width: 100%;
  padding: 4vw;
  margin-top: 2.5vw;
  border: none;
  border-radius: 2vw;
  font-size: 4.5vw;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: background-color 0.3s ease;
}

.payment-button:active {
  transform: scale(0.98);
}

.payment-button.loading {
  pointer-events: none;
}

.payment-button.loading::after {
  content: "";
  position: absolute;
  width: 5vw;
  height: 5vw;
  top: 50%;
  left: 50%;
  margin-top: -2.5vw;
  margin-left: -2.5vw;
  border: 0.5vw solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
}

.phonepe-button {
  background-color: #5f259f;
  color: white;
}

.gpay-button {
  background-color: #4285f4;
  color: white;
}

.payment-processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.payment-processing-message {
  text-align: center;
}

.dot-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12.5vw;
}

.dot {
  width: 2.5vw;
  height: 2.5vw;
  background-color: #333;
  border-radius: 50%;
  margin: 0 1.25vw;
  animation: bounce 0.5s ease-in-out infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.2s;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2.5vw); }
}

.empty-cart {
  text-align: center;
  padding: 10vw 5vw;
}

.empty-cart h2 {
  font-size: 6vw;
  color: #333;
  margin-bottom: 5vw;
}

.empty-cart-button {
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 3vw 6vw;
  font-size: 4vw;
  font-weight: 600;
  border-radius: 1vw;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cash-button {
  background-color: #4caf50;
  color: white;
}

.additional-options {
  margin-top: 5vw;
  padding-top: 2.5vw;
  border-top: 0.25vw solid #e0e0e0;
}

.additional-options p {
  margin-bottom: 2.5vw;
  font-size: 3.5vw;
  color: #666;
}

.additional-links {
  display: flex;
  justify-content: space-between;
}

.additional-links a {
  color: #1976d2;
  text-decoration: none;
  font-size: 3.5vw;
}

.dot-loader.small {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 5vw;
}

.dot-loader.small .dot {
  width: 1.25vw;
  height: 1.25vw;
  background-color: #1976d2;
  border-radius: 50%;
  margin: 0 0.5vw;
  animation: bounce 0.5s ease-in-out infinite;
}

.dot-loader.small .dot:nth-child(2) {
  animation-delay: 0.1s;
}

.dot-loader.small .dot:nth-child(3) {
  animation-delay: 0.2s;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  padding: 5vw;
  border-radius: 2vw;
  text-align: center;
}

.countdown {
  font-size: 3.5vw;
  color: #666;
  margin-left: 2vw;
}

.safe-area-bottom {
  padding-bottom: 0;
}  

@media (min-width: 768px) {
  .section-title {
    font-size: 2.25vw;
  }

  .pickup-date {
    font-size: 2vw;
  }

  .delivery-point-name {
    font-size: 2.25vw;
  }

  .delivery-point-address {
    font-size: 1.75vw;
  }

  .delivery-point-title {
    font-size: 1.75vw;
  }

  .change-delivery-point-button {
    font-size: 1.75vw;
    padding: 1vw 2vw;
  }

  .user-info {
    font-size: 2vw;
  }

  .cart-summary-bar {
    font-size: 2vw;
  }

  .cart-item-title {
    font-size: 2vw;
  }

  .cart-item-price {
    font-size: 1.875vw;
  }

  .cart-quantity-button {
    width: 10vw;
    height: 3.5vw;
  }

  .cart-quantity-button button {
    font-size: 2.25vw;
    width: 3.5vw;
    height: 3.5vw;
  }

  .cart-quantity-button span {
    font-size: 1.75vw;
  }

  .cart-item-subtotal {
    font-size: 1.875vw;
  }

  .total-price {
    font-size: 2.25vw;
  }

  .confirm-button {
    font-size: 2.25vw;
    padding: 3.25vw;
  }

  .payment-button {
    font-size: 2.25vw;
  }

  .empty-cart h2 {
    font-size: 3vw;
  }

  .empty-cart-button {
    font-size: 2vw;
    padding: 1.5vw 3vw;
  }

  .additional-options p,
  .additional-links a {
    font-size: 1.75vw;
  }

  .countdown {
    font-size: 1.75vw;
  }
}

@media (min-width: 1024px) {
  .section-title {
    font-size: 1.5vw;
  }

  .pickup-date {
    font-size: 1.3vw;
  }

  .delivery-point-name {
    font-size: 1.5vw;
  }

  .delivery-point-title {
    font-size: 1.2vw;
  }

  .delivery-point-address {
    font-size: 1.2vw;
  }

  .change-delivery-point-button {
    font-size: 1.2vw;
    padding: 0.7vw 1.4vw;
  }

  .user-info {
    font-size: 1.3vw;
  }

  .cart-summary-bar {
    font-size: 1.3vw;
  }

  .cart-item-title {
    font-size: 1.3vw;
  }

  .cart-item-price {
    font-size: 1.2vw;
  }

  .cart-quantity-button {
    width: 7vw;
    height: 2.5vw;
  }

  .cart-quantity-button button {
    font-size: 1.5vw;
    width: 2.5vw;
    height: 2.5vw;
  }

  .cart-quantity-button span {
    font-size: 1.2vw;
  }

  .cart-item-subtotal {
    font-size: 1.2vw;
  }

  .total-price {
    font-size: 1.5vw;
  }

  .confirm-button {
    font-size: 1.5vw;
    padding: 2vw;
  }

  .payment-button {
    font-size: 1.5vw;
  }

  .empty-cart h2 {
    font-size: 2vw;
  }

  .empty-cart-button {
    font-size: 1.3vw;
    padding: 1vw 2vw;
  }

  .additional-options p,
  .additional-links a {
    font-size: 1.2vw;
  }

  .countdown {
    font-size: 1.2vw;
  }
}
</style>




<div class="main-content1">

  <div class="back-button-container1">
    <button class="back-button1" on:click={handleBackButtonClick}>
      <img src={backarrow} alt="Back" />
    </button>
  </div>

  <div class="container">
	<div class="pickup-info">
	  <h2 class="section-title">Pickup Date:</h2>
	  {#if checkoutResponse.cart}
		<p class="pickup-date">
		  {formatDate(pickupDate)} ({pickupDay})
		</p>
	  {/if}
	</div>


	{#if deliveryPointStatus && deliveryPointStatus.delivery_slot && deliveryPointStatus.delivery_slot.delivery_time}
	  <div class="pickup-info">
		<h2 class="section-title">Time:</h2>
		<p class="pickup-date">Collect after 
		  {formatTime(deliveryPointStatus.delivery_slot.delivery_time)}
		</p>
	  </div>
	{/if}


    <div class="delivery-point" class:unavailable={deliveryPointStatus?.availability_status === 'No'}>
      {#if deliveryPointStatus}
        <p class="delivery-point-area-label">{deliveryPointStatus.delivery_point.area_label}</p>
        <p class="delivery-point-title">{deliveryPointStatus.delivery_point.name}</p>
        <p class="delivery-point-address">
          {@html deliveryPointStatus.delivery_point.address.replace(/\r\n/g, '<br>')}
        </p>
        {#if deliveryPointStatus.availability_status === 'No'}
          <p class="unavailable-label">
            {deliveryPointStatus.delivery_point.name} is not available
          </p>
          <p>{deliveryPointStatus.message}</p>
        {/if}
      {/if}
    </div>


  </div>

  <div class="container1">
    <h2 class="section-title">Cart Summary</h2>
    {#if checkoutResponse.cart}
      <div class="cart-summary-bar">
        {checkoutResponse.cart.total_no_of_products} product(s) in cart
      </div>
      {#each checkoutResponse.cart.items as item}
		<div class="cart-item" class:loading={updatingItems.has(item.product__id)}>
		  <div class="cart-item-details">
			<h3 class="cart-item-title">{item.product__title}</h3>
			<p class="cart-item-price">
			  {item.product__unit} {item.product__measurement_unit} • ₹{item.price}
			</p>
		  </div>
		  <div class="cart-item-actions">
			<div class="cart-quantity-button">
			  <button on:click={() => handleQuantityChange(item.product__id, item.quantity - 1)}>−</button>
			  <span>{item.quantity}</span>
			  <button on:click={() => handleQuantityChange(item.product__id, item.quantity + 1)}>+</button>
			</div>
			<p class="cart-item-subtotal">₹{item.subtotal}</p>
		  </div>
		</div>
      {/each}
      <p class="total-price">
        Total: 
        {#if isUpdatingTotal}
          <span class="spinner"></span>
        {:else}
          ₹{checkoutResponse.cart.total_price}
        {/if}
      </p>
    {/if}
  </div>

  <div class="container2">
    <div class="user-details">
      <p class="user-info"><strong>Your name:</strong> {checkoutResponse.cart?.user_name}</p>
      <p class="user-info"><strong>Your mobile:</strong> {checkoutResponse.cart?.user_phone}</p>
    </div>
  </div>
</div>


<div class="confirm-button-container">
  <button
    class="confirm-button"
    class:disabled={!isOrderButtonActive}
    on:click={handleOrderNow}
    disabled={!isOrderButtonActive}
  >
    <span>₹{checkoutResponse.cart?.total_price}</span>
    {#if isPlacingOrder || isUpdatingTotal}
      <span class="spinner"></span>
    {:else}
      <span>Confirm</span>
    {/if}
  </button>
</div>



{#if !checkoutResponse.cart || checkoutResponse.cart.items.length === 0}
  <div class="empty-cart">
    <h2>Your cart is empty</h2>
    <button class="empty-cart-button" on:click={handleBackButtonClick}>
      Add Products
    </button>
  </div>
{:else}
  <!-- Existing cart content -->
{/if}



{#if showPaymentModal}
  <div class="payment-modal-overlay" on:click={closePaymentModal}>
    <div class="payment-modal" on:click|stopPropagation>
      <button class="close-modal-button" on:click={closePaymentModal}>&times;</button>
      <h2>Complete Your Payment</h2>
      <p>Total: ₹{checkoutResponse.cart?.total_price}</p>

		<button 
		  class="payment-button phonepe-button" 
		  class:loading={loadingButton === 'phonepeUrl'}
		  on:click={() => handlePaymentClick('phonepeUrl')}
		  disabled={loadingButton !== null}
		>
		  Pay with PhonePe
		</button>

		<button 
		  class="payment-button gpay-button" 
		  class:loading={loadingButton === 'gpayUrl'}
		  on:click={() => handlePaymentClick('gpayUrl')}
		  disabled={loadingButton !== null}
		>
		  Pay with GPay
		</button>

		{#if userPaymentPreference === 'Cash'}
		  <button 
			class="payment-button cash-button" 
			class:loading={loadingButton === 'cash'}
			on:click={() => handlePaymentClick('cash')}
			disabled={loadingButton !== null}
		  >
			Pay with Cash
		  </button>
		{/if}

		<div class="additional-options">
		  <div class="additional-links">
			<a href="#" on:click|preventDefault={() => placeOrder('intentUrl')}>
			  {#if showUpiLoader}
				<span class="dot-loader small">
				  <span class="dot"></span>
				  <span class="dot"></span>
				  <span class="dot"></span>
				</span>
			  {:else}
				Or Pay with other UPI apps
			  {/if}
			</a>
		  </div>
		</div>
		
    </div>
  </div>
{/if}




{#if showPaymentFailedModal}
  <div class="payment-modal-overlay" on:click={closePaymentModal}>
    <div class="payment-modal" on:click|stopPropagation>
      <button class="close-modal-button" on:click={closePaymentFailedModal}>&times;</button>
      <h2>Payment Pending...</h2>
      <p>Please retry. Don't worry if you already made the payment, order will get automatically confirmed within 10 minutes.</p>	  
	  
      <p>Amount: ₹{checkoutResponse.cart?.total_price}</p>
	  
		<button 
		  class="payment-button phonepe-button" 
		  class:loading={loadingButton === 'phonepeUrl'}
		  on:click={() => handlePaymentClick('phonepeUrl')}
		  disabled={loadingButton !== null}
		>
		  Pay with PhonePe
		</button>

		<button 
		  class="payment-button gpay-button" 
		  class:loading={loadingButton === 'gpayUrl'}
		  on:click={() => handlePaymentClick('gpayUrl')}
		  disabled={loadingButton !== null}
		>
		  Pay with GPay
		</button>

		{#if userPaymentPreference === 'Cash'}
		  <button 
			class="payment-button cash-button" 
			class:loading={loadingButton === 'cash'}
			on:click={() => handlePaymentClick('cash')}
			disabled={loadingButton !== null}
		  >
			Pay with Cash
		  </button>
		{/if}

		<div class="additional-options">
		  <div class="additional-links">
			<a href="#" on:click|preventDefault={() => placeOrder('intentUrl')}>
			  {#if showUpiLoader}
				<span class="dot-loader small">
				  <span class="dot"></span>
				  <span class="dot"></span>
				  <span class="dot"></span>
				</span>
			  {:else}
				Or Pay with other UPI apps
			  {/if}
			</a>
		  </div>
		</div>
		
    </div>
  </div>
{/if}



{#if isProcessingPayment}
  <div class="payment-processing-overlay">
    <div class="payment-processing-message">
    <span class="countdown">{formatTimeCheck(countdownTime)}</span>
      <h3>
        Checking Payment Status
      </h3>
      <h4>Please Wait</h4>
      <div class="dot-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </div>
{/if}


{#if isStartingPayment}
  <div class="payment-processing-overlay">
    <div class="payment-processing-message">
      <h3>Opening UPI App..</h3>
      <div class="dot-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </div>
{/if}


<DeliveryPointModal
  isOpen={showModal}
  deliveryPoints={availableDeliveryPoints}
  {isLoading}
  on:close={handleModalClose}
  on:select={handleDeliveryPointSelection}
/>


<DeliverySlotModal
  isOpen={showSlotModal}
  deliverySlots={availableDeliverySlots}
  {isLoading}
  on:close={() => showSlotModal = false}
  on:select={handleDeliverySlotSelection}
/>

{#if showOutOfStockPopup}
  <OutOfStockPopup 
    productsNotAdded={checkoutResponse.products_not_added} 
    onClose={closeOutOfStockPopup}
  />
{/if}


{#if showOutOfStockPopup2}
  <OutOfStockPopup2 error={outOfStockError2} onClose={closeOutOfStockPopup2} />
{/if}

{#if showNewSlotPopup}
  <div class="popup-overlay">
    <div class="popup-content">
      <p>New Delivery Slot: {newDeliverySlotTime}</p>
      <button on:click={handleNewSlotOkay}>Okay</button>
    </div>
  </div>
{/if}